import { LoadingOverlay } from "@mantine/core";

const CustomLoader = ({ visible }) => (
   <LoadingOverlay
      visible={visible} overlayBlur={2} loaderProps={
         {
            color: "red",
            size: 50,
         }
      }
      zIndex={1} />
);

export default CustomLoader;
